/*
 * fn: parseRouteParam
 *
 * Reads a single raw URL value into its route param value
 *
 */
import {
  getRouteParamConfig,
  type RouteParamsConfigType,
  type RouteParamsType,
  type RouteParamValueType,
} from '@/defs/route'

import { parseAdvancedRoute } from './parseAdvancedRoute'

type ParserType = NonNullable<RouteParamsConfigType['parser']>

const PARSERS = {
  advancedFilters: (key: string) => {
    const advancedFilters = parseAdvancedRoute(key)
    return advancedFilters?.length ? advancedFilters : undefined
  },
  pageNumber: (key: string) => {
    const num = Number(key)
    return num > 1 ? num : undefined
  },
} satisfies { [K in ParserType]: (key: string) => RouteParamsType[K] }

export const parseRouteParam = (param: keyof RouteParamsType, key?: string): RouteParamValueType => {
  const { check, parser } = getRouteParamConfig(param)

  if (key === undefined || !check(key)) return

  return parser ? PARSERS[parser](key) : key
}
